<mat-dialog-content class="modal-header"><h2 mat-dialog-title>REGISTRAR ACCIÓN</h2></mat-dialog-content>
    <mat-dialog-content class="modal-body">
        <div class="content">
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="col-md-2 control-label">Detalle (*):</label>
                    <div class="col-md-10">
                      <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Detalle</mat-label>
                        <textarea
                            matInput
                            placeholder="Detalle"
                            rows="5"
                            [(ngModel)]="data.detalle"                      
                            name="detalle" maxlength="2000"
                            ></textarea>
                      </mat-form-field>                
                    </div> 
                </div> 
                <div class="form-group">
                    <label class="col-md-2 control-label">Fecha Limite (*):</label>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Fecha Limite</mat-label>
                        <input matInput [matDatepicker]="pckrFechaLimite" [(ngModel)]="data.fechaLimite" id="fechaLimite" name="fechaLimite" required />
                    <mat-datepicker-toggle matSuffix [for]="pckrFechaLimite"></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaLimite></mat-datepicker>
                      </mat-form-field>                
                    </div> 
                    <label class="col-md-2 control-label">Fecha Real Cierre:</label>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Fecha Limite</mat-label>
                        <input matInput [matDatepicker]="pckrFechaCierre" [(ngModel)]="data.fechaCierre" id="fechaCierre" name="fechaCierre" />
                    <mat-datepicker-toggle matSuffix [for]="pckrFechaCierre"></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaCierre></mat-datepicker>
                      </mat-form-field>                
                    </div> 
                </div> 
                <div class="form-group">
                    <label class="col-md-2 control-label">Estado:</label>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Estado</mat-label>
                        <mat-select matSelect
                  [(ngModel)]="data.idEstado"
                  name="idEstado"
                  #idEstado="ngModel" required>
                    <mat-option
                            *ngFor="let item of listaEstados; index as i"
                            [value]="item.idParametroDetalle"
                            >{{ item.nombre }}</mat-option>
                  </mat-select>
                      </mat-form-field>                
                    </div> 
                </div> 
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="modal-actions">
        <button class="btn btn-naranja" mat-button [disabled]="!EsValido()" (click)="onSaveClick()" >Guardar</button>
        <button type="button" class="btn btn-naranja2" mat-button  (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Salir</button>
      </mat-dialog-actions>
